import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import { TRegisterRequest } from '../types/requests';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function OnboardingController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.ONBOARDING;

  const register = <T>(data: TRegisterRequest): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/register`, options);
  };

  const setPricingPlan = <T>(data: {
    shopName: string,
    planName: 'free' | 'lite' | 'standard' | 'enterprise'
  }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest('installation/planSelected', options);
  };

  return {
    register,
    setPricingPlan,
  };
}
